export default {
  path: ":alias/treeTypes",
  component: resolve => require(["@/views/tree-types"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/tree-types/list"], resolve)
    },
    {
      path: "list/form/:id?",
      component: resolve => require(["@/views/tree-types/form"], resolve)
    }
  ]
};
